// extracted by mini-css-extract-plugin
export default {"container":"not_found_message_container__pk48B","notFound":"not_found_message_notFound__kiuuV"};